module.exports = __webpack_public_path__ + "img/phone.2915c6a7.svg";